import { render } from "./LoanAndNFTDetailsCard.vue?vue&type=template&id=12926995&scoped=true"
import script from "./LoanAndNFTDetailsCard.vue?vue&type=script&lang=js"
export * from "./LoanAndNFTDetailsCard.vue?vue&type=script&lang=js"

import "./LoanAndNFTDetailsCard.vue?vue&type=style&index=0&id=12926995&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12926995"]])

export default __exports__